import axios from "axios";
import { baseUrl } from "./baseUrl";

const api = axios.create({
    baseURL: `${baseUrl}/admin/auth`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('cc-t') || sessionStorage.getItem('cc-t');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getAdminsList = async () => {
    try {
        const res = await api.get('/admin-list');
        return res.data.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const getAdminTypesList = async () => {
    try {
        const res = await api.get('/admin-types-list');
        return res.data.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const createAdmin = async (adminData) => {
    try {
        const res = await api.post('/add-admin', adminData);
        return res.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const updateAdmin = async ({ adminId, adminData }) => {
    try {
        const res = await api.put(`/update-admin/${adminId}`, adminData);
        return res.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const deleteAdmin = async (adminId) => {
    try {
        const res = await api.delete(`/delete-admin/${adminId}`);
        return res.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}